import { render, staticRenderFns } from "./ScopeDeleteModal.vue?vue&type=template&id=f5121d6e&scoped=true&"
import script from "./ScopeDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ScopeDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./ScopeDeleteModal.vue?vue&type=style&index=0&id=f5121d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5121d6e",
  null
  
)

export default component.exports